export const FirearmActionConstants = {
    OTHER: '',
}